import { PermissionRequest } from "@p0security/shared/types/permission";
import { useMemo } from "react";

import { extractApproverName, requestorAttribution } from "../requestUtils";
import { PermissionPreview } from "./PermissionPreview";

export const RequestPreview: React.FC<{
  requestId: string;
  request: PermissionRequest;
}> = ({ requestId, request }) => {
  const requestVerbiage = useMemo(() => {
    return {
      requestor: requestorAttribution(request),
      requestVerb: request.grantTimestamp ? "was granted" : "is requesting",
    };
  }, [request]);

  return (
    <PermissionPreview
      requestor={requestVerbiage.requestor}
      verb={requestVerbiage.requestVerb}
      permission={request}
      reason={request.reason}
      createdAt={request.approvalDetails?.approvedTimestamp}
      approverType={request.approvalDetails?.approvalSource}
      approverDetail={extractApproverName(request, true)}
      requestId={requestId}
    />
  );
};
